import { get } from 'lodash'
import { useQuery } from 'react-query'
import { AxiosError } from 'axios'

import { fetchAPI } from '@/lib/api'

import { Submission, Campaign, CampaignType } from '../types'
import { Meta } from '@/features/filters/types'

import { SUBMISSIONS } from '../constants'

type SubmissionsResponse = {
  data: Submission[]
  meta: Meta
}

const getSubmissions = async (
  campaign: Campaign,
  params: Meta,
): Promise<SubmissionsResponse> => {
  const response = await fetchAPI({
    path: `/campaigns/${campaign.id}/submissions`,
    params,
  })

  const key =
    campaign.campaign_type === CampaignType.third_campaign
      ? 'posts'
      : 'submissions'
  const data = get(response, `data.${key}`, [])
  const meta = get(response, 'data.meta', {})

  return { data, meta }
}

export const useSubmissions = ({
  campaign,
  params = {},
  initialData,
}: {
  campaign: Campaign
  params?: Meta
  initialData?: SubmissionsResponse
}) => {
  return useQuery<SubmissionsResponse, AxiosError>({
    queryKey: [SUBMISSIONS, campaign.id, params],
    queryFn: () => getSubmissions(campaign, params),
    keepPreviousData: true,
    initialData,
  })
}
